//Header Header.jsx

export const header = {
    "Sub0": "Home",
    "Sub1": "Catálogo",
    "Sub1All": "Todos los productos",
    "Sub2": "Blog",
    "Sub3": "Sobre nosotros",
    "Sub4": "Contacto"
};